// extracted by mini-css-extract-plugin
export default {"container":"protocol-component_container__5R5nl","content":"protocol-component_content__2I4ug","fullscreen":"protocol-component_fullscreen__OHoqd"};